import { render, staticRenderFns } from "./joinlist.vue?vue&type=template&id=49d366e6"
import script from "./joinlist.vue?vue&type=script&lang=js"
export * from "./joinlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports